import React from 'react';
import { Button, Text, useTheme } from "@chakra-ui/react";
import { CTAButtonTypes } from "./CTAButtonTypes";
import { Link } from 'gatsby-link';
import { hexToRgba } from '../../utils/mapEnum';


export const CallToActionButton = (callToAction: CTAButtonTypes.TCallToAction) => {
    const {
        showButton,
        link,
        label,
        buttonTypes,
        buttonSize,
        buttonColor,
        textColor,
        textSize,
        otherButtonProps,
        options,
        url,
        onClick,
    } = callToAction;

    const theme = useTheme();
    const originalColor = theme.colors.brand[`${buttonColor}`];
    const lightButtonColor = hexToRgba(originalColor, 0.9);
    const outputTextColor = () => {
        if (typeof (textColor) === 'object') {
            return textColor;
        } else {
            return `brand.${textColor}`;
        }
    };

    return showButton ?
        <Link
            to={link || url}
            state={options}
            target='_blank'
        >
            <Button
                _hover={{ bg: originalColor, borderColor: originalColor }}
                _active={{ bg: originalColor }}
                size={buttonSize}
                variant={buttonTypes}
                color={originalColor}
                bg={buttonTypes !== 'outline' ? lightButtonColor : 'initial'}
                borderColor={lightButtonColor}
                onClick={onClick}
                {...otherButtonProps}
            >
                <Text color={outputTextColor()} textStyle={textSize} >
                    {label}
                </Text>
            </Button>
        </Link > : null
}